import { FC } from 'react';
import InfoTag from 'components/InfoTag/InfoTag';
import useSideFormDetails from 'components/SideFormDetails/SideFormDetails.hook';
import { sideContainerStyle, sideContainerStyleInnerBox } from 'components/SideFormDetails/SideFormDetails.styles';
import UpdateBanner from 'components/SideFormDetails/UpdateBanner/UpdateBanner';
import Box from 'yoda-ui/components/Box';

const SideContainer: FC = () => {
  const {
    date,
    cepStateValue,
    productName,
    t,
  } = useSideFormDetails();

  return (
    cepStateValue.cep?.title || cepStateValue.cep?.updated
      ? <Box sx={ sideContainerStyle.root }>
        {
          cepStateValue.cep?.title
            ? <Box sx={ sideContainerStyle.firstBox }>
              <Box>
                <Box sx={ sideContainerStyle.title }>
                  { t('maya_side_details_title') }
                </Box>
                <Box sx={ sideContainerStyle.cepTitle }>
                  { cepStateValue.cep?.title }
                </Box>
                <Box sx={ sideContainerStyleInnerBox }>
                  <InfoTag
                    title={ t('maya_side_details_date') }
                    field={ date }
                    sx={ { whiteSpace: 'nowrap' } }
                  />
                  <InfoTag
                    title={ t('maya_side_details_therapeutic_area') }
                    field={ cepStateValue.cep?.therapeuticArea }
                  />
                  <InfoTag
                    title={ t('maya_side_details_product') }
                    field={ productName }
                  />
                </Box>
              </Box>
            </Box>
            : null
        }
        {
          cepStateValue.cep?.updated
            ? <UpdateBanner />
            : null
        }
      </Box>
      : null
  );
};

export default SideContainer;
